/* Poke-Collect Add-Ons — one-tap "+ Add" for the cart drawer row and the product page "Pairs Well With" block.
   Self-contained: talks to Shopify's /cart/add.js with the Section Rendering API and swaps the drawer's own markup in place
   (line items, subtotal, header count). The add-ons row lives inside the drawer's item list, so it refreshes with it. */
(function () {
  if (window.__pcAddons) return;
  window.__pcAddons = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function swap(sel, html) {
    var live = document.querySelector(sel);
    if (!live || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector(sel);
    if (fresh) live.innerHTML = fresh.innerHTML;
  }

  function refresh(sections) {
    if (!sections) return;
    var drawer = document.querySelector('cart-drawer');
    var row = drawer && drawer.querySelector('[data-pca-row]');
    var keepLeft = row ? row.scrollLeft : 0;

    if (drawer && sections['cart-drawer']) {
      swap('cart-drawer .cart-drawer__items', sections['cart-drawer']);
      swap('cart-drawer .cart-drawer__footer--subtotal', sections['cart-drawer']);
      drawer.classList.remove('is-empty');
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      var nrow = drawer.querySelector('[data-pca-row]');
      if (nrow) { nrow.scrollLeft = keepLeft; nrow.classList.add('is-fresh'); arrows(nrow); }
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var d = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var wrap = d.querySelector('.shopify-section') || d.body;
        bubble.innerHTML = wrap.innerHTML;
      }
    }
  }

  function syncCounts() {
    /* other cart counters on the site (e.g. the phone menu) */
    fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-pcn-cart-count]').forEach(function (b) { b.textContent = c.item_count; b.hidden = !c.item_count; });
      document.dispatchEvent(new CustomEvent('pc:cart:updated', { detail: { cart: c, source: 'addons' } }));
    }).catch(function () {});
  }

  function say(box, text) {
    var m = box && box.querySelector('[data-pca-msg]');
    if (!m) return;
    m.textContent = text;
    clearTimeout(m._t);
    m._t = setTimeout(function () { m.textContent = ''; }, 4000);
  }

  function add(btn) {
    var box = btn.closest('[data-pca]');
    var mode = box ? box.getAttribute('data-pca-mode') : 'drawer';
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id || btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: SECTIONS, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        if (!res.ok || res.j.status) {
          say(box, res.j.description || res.j.message || 'Couldn’t Add That Item. Please Try Again.');
          return;
        }
        btn.classList.add('is-done');
        var item = btn.closest('.pca-item');
        if (mode === 'drawer') {
          /* brief "Added" tick, then the drawer (and this row, without the added item) re-renders */
          setTimeout(function () {
            if (item) item.classList.add('is-leaving');
            setTimeout(function () { refresh(res.j.sections); syncCounts(); }, 260);
          }, 450);
        } else {
          refresh(res.j.sections);
          syncCounts();
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') setTimeout(function () { drawer.open(); }, 350);
        }
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        say(box, 'Couldn’t Add That Item. Please Try Again.');
      });
  }

  function arrows(row) {
    var box = row.closest('[data-pca]');
    if (!box) return;
    var prev = box.querySelector('[data-pca-prev]'), next = box.querySelector('[data-pca-next]');
    if (!prev || !next) return;
    var max = row.scrollWidth - row.clientWidth - 2;
    prev.disabled = row.scrollLeft <= 2;
    next.disabled = row.scrollLeft >= max;
    var hide = row.scrollWidth <= row.clientWidth + 2;
    prev.parentNode.hidden = hide;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pca-add]');
    if (btn) { e.preventDefault(); e.stopPropagation(); add(btn); return; }
    var nav = e.target.closest && e.target.closest('[data-pca-prev],[data-pca-next]');
    if (nav) {
      e.preventDefault();
      var row = nav.closest('[data-pca]').querySelector('[data-pca-row]');
      var card = row.querySelector('.pca-item');
      var step = card ? (card.getBoundingClientRect().width + 10) * 2 : 290;
      row.scrollBy({ left: nav.hasAttribute('data-pca-prev') ? -step : step, behavior: 'smooth' });
    }
  });

  /* keep arrow states right while swiping (scroll doesn't bubble, so listen in the capture phase) */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute('data-pca-row')) arrows(t);
  }, true);

  /* first paint, and whenever the drawer opens or its markup is replaced by the theme */
  function scan() { document.querySelectorAll('[data-pca-row]').forEach(arrows); }
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('resize', scan);
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(scan, 60); });
    var start = function () { var d = document.querySelector('cart-drawer'); if (d) mo.observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }
})();
